import Modal, { ModalProps } from "../Modal";
import React from "react";
import styles from "./styles.module.scss";

export interface MessageModalProps extends ModalProps {
  message: string;
}

const MessageModal = (props: MessageModalProps) => {
  const { message } = props;
  return (
    <Modal {...props}>
      <div
        className={styles.message}
        dangerouslySetInnerHTML={{ __html: message }}
      />
    </Modal>
  );
};
export default MessageModal;
export { MessageModal };
